import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

const Loader = () => (
    <Box p={1}>
        <CircularProgress />
    </Box>
);

export default Loader;